//React
import React, { Component } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Link } from "react-router-dom";
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useTranslation, withTranslation } from "react-i18next";

//CSS, STYLES & MEDIA ASSETS
import "./Register.scss";
//mport logo from "../../utils/logo_MPDS.svg";
import logo from "../../utils/logo_MPDS_ecossistema.svg";

//ACTIONS
import { login, getToken, resetPassword } from '../../store/actions/login/loginActions'

//OUTSIDE COMPONENTS
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Image from 'react-bootstrap/Image'
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField'

const languages = [
  {
    value: 'pt-PT',
    label: 'Português',

  },
  {
    value: 'en-US',
    label: 'English',
  }
];

function Page() {
  const { i18n } = useTranslation();

  const changeLanguage = (event, lng) => {
    i18n.changeLanguage(event, lng);
  };

  let languageStorage = localStorage.getItem('i18nextLng')
  if (languageStorage != null && languageStorage !== "") {
    if (languageStorage !== "pt-PT" && languageStorage !== "en-US") {
      if (languageStorage.length > 2) {
        let abrvLang = languageStorage.substr(0, 2).toLowerCase();
        if (abrvLang === "en") {
          languageStorage = 'en-US'
        } else {
          languageStorage = 'pt-PT'
        }
      } else {
        languageStorage = 'pt-PT'
      }
    }
  } else {
    languageStorage = 'pt-PT'
  }

  const [values, setValues] = React.useState({
    language: languageStorage
  });

  const handleChange = name => event => {
    setValues({ ...values, [name]: event.target.value });
    /** Change to the clicked language */
    changeLanguage(event.target.value)
  };

  return (
    <div className="text-center pb-5-freetrial mt-idioma">

      <TextField
        id="standard-select-currency"
        select
        inputProps={{ className: "pl-3" }}
        value={values.language}
        onChange={handleChange('language')}
        margin="normal"
      >

        {languages.map(option => (
          <MenuItem key={option.value} value={option.value} dense={true}>
            {option.label}
          </MenuItem>
        ))}


      </TextField>

    </div>
  );
}

class RegisterFreeTrial extends Component {
  constructor(props) {
    super(props)
    this.state = { selectedInstitution: null, resetPass: false, showError: true, error: null, showErrorMessage: false, errorMessageSnack: "", showedError: false }
    
    document.getElementById('root').style.background = "#f4fafb"

  }
  
  render(){
    const { t } = this.props;


    return (
      <Container className="background login-illustration-register">
          <Row className="vh-100">
            <Col xs sm md={12} lg={12}>
              <Page />
              <Image src={logo} className="App-logo d-block mx-auto my-md-5 my-3 mb-logo-trial" fluid alt="logo" />
              <div>
                <label className="bem-vindo mx-auto">{t('FreeTrial.Welcome')}</label>
                <div className="container-label">
                <label className="label-register-use-freetrial">{t('FreeTrial.RegisterUse')}</label>
                </div>
                <br/>
                <div className="container-registrado">
                  <div className="principais-vantagens">
                    <label className="principais-vantanges-label">{t('FreeTrial.MainFeatures')}</label>
                    <div className="div-line-principais-vantagens">
                      <div class="div-line-principais-vantagens-icon">
                        <img src="..\images\icon.svg" className="img-seta mx-auto d-block" alt="" align="left"></img>
                      </div>
                      <div class="div-line-principais-vantagens-text">
                        <label className="principais-vantagens-text">{t('FreeTrial.MainFeatures1')}</label>
                      </div>
                    </div>
                    {/* <div className="div-line-principais-vantagens">
                      <div class="div-line-principais-vantagens-icon">
                        <img src="..\images\icon.svg" className="img-seta mx-auto d-block" alt="" align="left"></img>
                      </div>
                      <div class="div-line-principais-vantagens-text">
                        <label className="principais-vantagens-text">{t('FreeTrial.MainFeatures2')}</label>
                      </div>
                    </div> */}
                    <div className="div-line-principais-vantagens">
                      <img src="..\images\icon.svg" className="img-seta mx-auto d-block" alt="" align="left"></img>
                      <label className="principais-vantagens-text">{t('FreeTrial.MainFeatures3')}</label>
                    </div>
                    <div className="div-line-principais-vantagens">
                      <img src="..\images\icon.svg" className="img-seta mx-auto d-block" alt="" align="left"></img>
                      <label className="principais-vantagens-text">{t('FreeTrial.MainFeatures4')}</label>
                    </div>
                    <div className="div-line-principais-vantagens">
                      <img src="..\images\icon.svg" className="img-seta mx-auto d-block" alt="" align="left"></img>
                      <label className="principais-vantagens-text">{t('FreeTrial.MainFeatures5')}</label>
                    </div>
                  </div>
                </div>
                <Button component={Link} to="/register-trial/form" className="button-register d-block mx-auto mt-5 mb-4" color="primary" variant="contained"><span className="span-button-register">{t('Register')}</span></Button>
                <label className="label-registrado">{t('FreeTrial.AlreadyRegistered')} <span className="span-label-registrado"><Link to="/">{t('Login.Login')}</Link></span></label>
                <img width="200px" src="..\images\f3mfeelit-fundobranco.png" className="mx-auto d-block pt-5 mt-5" alt=""></img>
                <div class="div-sabermais-freetrial pt-3">
                  <label className="label-sabermais-link"><a href={t('urlMpDSSite')} target="_blank">{t('FreeTrial.ClickHere')}</a></label> <label className="label-sabermais">{t('FreeTrial.MoreInformation')}</label>
                </div>
              </div>
            </Col >
          </Row>
        </Container>
    )
  } 
}

const mapStateToProps = (state, ownProps) => ({ loginU: state.login });
const mapDispatchToProps = dispatch => bindActionCreators({ login, getToken, resetPassword }, dispatch)
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(RegisterFreeTrial))
